@file:UseContextualSerialization(LocalDate::class)

package pl.finn.forms.ezw

import io.kvision.types.LocalDate
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseContextualSerialization
import pl.finn.forms.Zalacznik


@Serializable
data class EzwForm(

  var rodzajInformacjiZawartejWZawiadomieniu: String? = null,
  var naglowek: Naglowek = Naglowek(),

  var blokA: BlokA = BlokA(),
  var blokB: BlokB = BlokB(),
  var trescZawiadomieniaList: ArrayList<TrescZawiadomienia> = arrayListOf<TrescZawiadomienia>(),
  var blokIList: ArrayList<BlokI> = arrayListOf<BlokI>(),
  var blokJList: ArrayList<BlokJ> = arrayListOf<BlokJ>(),
  var blokKList: ArrayList<BlokK> = arrayListOf<BlokK>(),
  var blokL: BlokL = BlokL(),
  var blokL2: BlokL2 = BlokL2()
)

@Serializable
data class Naglowek (
  var kodUrzedu: String? = null
)

@Serializable
data class TrescZawiadomienia(
  var blokC: BlokC = BlokC(),
  var blokD: BlokD = BlokD(),
  var blokEFG: BlokEFG = BlokEFG(),
  var blokHList: ArrayList<BlokH> = arrayListOf<BlokH>(),
  var blokH1List: ArrayList<BlokH1> = arrayListOf<BlokH1>(),
  var blokIList: ArrayList<BlokI> = arrayListOf<BlokI>(),
  var blokJList: ArrayList<BlokJ> = arrayListOf<BlokJ>(),
  var blokKList: ArrayList<BlokK> = arrayListOf<BlokK>(),
)

@Serializable
data class BlokEFG(
  var rodzajBloku: String? = null,

  var blokEList: ArrayList<BlokE> = arrayListOf<BlokE>(),
  var blokFList: ArrayList<BlokF> = arrayListOf<BlokF>(),
  var blokGList: ArrayList<BlokG> = arrayListOf<BlokG>(),
)

@Serializable
data class EzwFormData(
  val form: EzwForm,
  val url: String,
  val token: String?
)

@Serializable
data class BlokA(
  var wierzyciel: Wierzyciel = Wierzyciel(),
  var organObslugujacy: OrganObslugujacy = OrganObslugujacy(),
)

@Serializable
data class Wierzyciel(
  var kodWierzyciela: String? = null,
  var nazwaWierzyciela: String? = null,
)

@Serializable
data class OrganObslugujacy(
  var nazwaOrganu: String? = null,
  var adres: AdresPolski = AdresPolski(),
  var admId: AdmIdWierzyciela = AdmIdWierzyciela(),
  var nrTelefonu: String? = null,
  var email: String? = null,
  var skrytkaEPuap: String? = null,
  var zmianaRachunkuList: ArrayList<ZmianaRachunku> = arrayListOf<ZmianaRachunku>(),
)

@Serializable
data class AdmIdWierzyciela(
  var nip: String? = null, //wymagany
  var regon: String? = null, //opcjonalny
)

@Serializable
data class AdmIdOsobaFizyczna(
  var identyfikatorGlowny: String? = null, //2 opcjonalne 1 wymagany
  var pesel: String? = null,
  var nip: String? = null,
  var innyIdentyfikator: String? = null,

  var oswiadczenieWierzyciela: Boolean = false, //zamiast identyfikatora
)

@Serializable
data class AdmIdOsobaNiefizyczna(
  var identyfikatorGlowny: String? = null, //3 opcjonalne 1 wymagany
  var nip: String? = null,
  var regon: String? = null,
  var krs: String? = null,
  var innyIdentyfikator: String? = null,

  var oswiadczenieWierzyciela: Boolean = false, //zamiast identyfikatora
  )

@Serializable
data class ZmianaRachunku(
  var nrRachunkuPLPoprzedni: String? = null,
  var nrRachunkuPLNowy: String? = null,
)

@Serializable
data class BlokB(
  var rodzajZobowiazanego: String? = null,
  val osobaFizyczna: OsobaFizyczna = OsobaFizyczna(),
  val osobaNiefizyczna: OsobaNiefizyczna = OsobaNiefizyczna(),
  val solidarni: Solidarni = Solidarni(),
  var zmianaDanych: Boolean = false
)

@Serializable
data class OsobaFizyczna(
  var imie: String? = null,
  var nazwisko: String? = null,
  var adres: Adres = Adres(),
  var admId: AdmIdOsobaFizyczna = AdmIdOsobaFizyczna(),
  var nrTelefonu: String? = null,
  var email: String? = null,
  var dataUrodzenia: Data = Data(),
  var imieOjca: String? = null,
  var imieMatki: String? = null,
  var skrytkaEPuap: String? = null,
)

@Serializable
data class OsobaNiefizyczna(
    var nazwa: String? = null,
    var adres: Adres = Adres(),
    var admId: AdmIdOsobaNiefizyczna = AdmIdOsobaNiefizyczna(),
    var nrTelefonu: String? = null,
    var email: String? = null,
    var skrytkaEPuap: String? = null,
    var wSpadku: Boolean = false,
)

@Serializable
data class Solidarni(
  var malzonek1: OsobaFizyczna = OsobaFizyczna(),
  var malzonek2: OsobaFizyczna = OsobaFizyczna(),
)

@Serializable
data class BlokC(
  var dataWystawienia: Data = Data(),
  var sygnatura: String? = null,
  var nrReferencyjny: String? = null,
)

@Serializable
data class BlokD(
  override var posiadaBlok: Boolean = false,

  var blokDWewnetrzny: ArrayList<BlokDWewnetrzny> = arrayListOf<BlokDWewnetrzny>(),
  var uzupelnienie: String? = null,
): BlokOpcjonalny

@Serializable
data class BlokDWewnetrzny(
  var powodZmianyWysokosciNaleznosciLubKosztowUpomnienia: String? = null,
  var wyegzekwowanie: Wyegzekwowanie = Wyegzekwowanie(),
  var korekta: Korekta = Korekta(),
  var przedawnienie: Przedawnienie = Przedawnienie(),
  var zaplata: Zaplata = Zaplata(),
  var inneZdarzenie: InneZdarzenie = InneZdarzenie(),
)

@Serializable
data class Wyegzekwowanie(
  var nazwaOE: String? = null,
  var dataOkresPowstaniaNaleznosci: DataLubPrzedzialDat = DataLubPrzedzialDat(),
  var dataWyegzekwowania: Data = Data(),
  var wysokoscPozostalejNaleznosci: Kwota = Kwota(),
  var wysokoscOdsetekNaDzien: Kwota = Kwota(),
  var wysokoscKosztow: Kwota = Kwota(),
  var wysokoscOdsetekNiezaplacenie: Kwota = Kwota(),
)

@Serializable
data class Korekta(
  var dataOkresPowstaniaNaleznosci: DataLubPrzedzialDat = DataLubPrzedzialDat(),
  var dataKorekty: Data = Data(),
  var wysokoscPozostalejNaleznosci: Kwota = Kwota(),
  var wysokoscOdsetekNaDzien: Kwota = Kwota(),
  var wysokoscKosztow: Kwota = Kwota(),
  var wysokoscOdsetekNiezaplacenie: Kwota = Kwota(),
)

@Serializable
data class Przedawnienie(
  var dataOkresPowstaniaNaleznosci: DataLubPrzedzialDat = DataLubPrzedzialDat(),
  var dataPrzedawnienia: Data = Data(),
  var wysokoscKosztow: Kwota = Kwota(),
)

@Serializable
data class Zaplata(
  var dataOkresPowstaniaNaleznosci: DataLubPrzedzialDat = DataLubPrzedzialDat(),
  var dataUzyskania: Data = Data(),
  var wysokoscUzyskanejNaleznosci: Kwota = Kwota(),
  var wysokoscUzyskanychOdsetek: Kwota = Kwota(),
  var wysokoscUzyskanychKosztow: Kwota = Kwota(),
  var wysokoscPozostalejNaleznosci: Kwota = Kwota(),
  var wysokoscOdsetekNaDzien: Kwota = Kwota(),
  var wysokoscKosztow: Kwota = Kwota(),
  var wysokoscOdsetekNiezaplacenie: Kwota = Kwota(),
  var podmiotZaplaty: String? = null,
)

@Serializable
data class InneZdarzenie(
  var opisZdarzenia: String? = null,
  var dataZdarzenia: Data = Data(),
  var dataOkresPowstaniaNaleznosci: DataLubPrzedzialDat = DataLubPrzedzialDat(),
  var wysokoscPozostalejNaleznosci: Kwota = Kwota(),
  var wysokoscOdsetekNaDzien: Kwota = Kwota(),
  var wysokoscKosztow: Kwota = Kwota(),
  var wysokoscOdsetekNiezaplacenie: Kwota = Kwota(),
)

@Serializable
data class BlokE(
  var przeslankaDoZawieszeniaPostepowania: String? = null, // "w calosci" lub "w czesci"
  var wCzesci: WCzesci = WCzesci(),
  var uwagi: String? = null,
  var dataOkresPodstawyPrawnej: DataLubPrzedzialDat = DataLubPrzedzialDat(),
  var podstawaPrawnaZawieszenia: String? = null, // Przesłanka zawieszenia postępowania
)

@Serializable
data class WCzesci(
  var dataOkresPowstaniaNaleznosci: DataLubPrzedzialDat = DataLubPrzedzialDat(),
  var wysokoscZawieszonejNaleznosci: Kwota = Kwota(),
  var wysokoscPozostalejNaleznosci: Kwota = Kwota(),
)

@Serializable
data class DataLubPrzedzialDat(
  var odDnia: LocalDate? = null,
  var doDnia: LocalDate? = null, //opcjonalne
)

@Serializable
data class BlokF(
  var przeslankaDoPodjeciaZawieszonegoPostepowania: String? = null, // "w calosci" lub "w czesci"
  var dataOkresPowstaniaNaleznosci: DataLubPrzedzialDat = DataLubPrzedzialDat(),
  var dataPodjecia: Data = Data(),
  var informacjaONaleznosci: InformacjaONaleznosci = InformacjaONaleznosci(),
  var zdarzeniePodjecia: String? = null,
  var uwagi: String? = null,
)

@Serializable
data class InformacjaONaleznosci(
  var wysokoscPozostalejNaleznosci: Kwota = Kwota(),
  var wysokoscOdsetekNaDzien: Kwota = Kwota(),
  var wysokoscKosztow: Kwota = Kwota(),
)

@Serializable
data class BlokG(
  var dataUmorzenia: Data = Data(),
  var umorzeniePostepowaniaEgzekucyjnego: String? = null, // "w calosci" lub "w czesci"
  var wCzesci: WCzesci = WCzesci(),
  var przeslankaUmorzenia: String? = null, //Przesłanka umorzenia postępowania
  var uwagi: String? = null,
)

@Serializable
data class BlokH(
  var dataOkresPowstaniaNaleznosci: DataLubPrzedzialDat = DataLubPrzedzialDat(),
  var nienaliczanieOdsetekList: ArrayList<NienaliczanieOdsetek> = arrayListOf<NienaliczanieOdsetek>()
)

@Serializable
data class NienaliczanieOdsetek(
  var okresNienaliczania: DataLubPrzedzialDat = DataLubPrzedzialDat(),
  var przyczynaNienaliczania: String? = null,
)

@Serializable
data class BlokH1(
  var dataOkresPowstaniaNaleznosci: DataLubPrzedzialDat = DataLubPrzedzialDat(),
  var dzienNienaliczania: Data = Data(),
  var przedmiotZabezpieczenia: String? = null
)

@Serializable
data class BlokI(
  var rodzajPodmiotu: String? = null,
  var czyOsobaFizyczna: Boolean = true,
  var imie: String? = null,
  var nazwisko: String? = null,
  var nazwa: String? = null,

  var adres: Adres = Adres(),
  var nrTelefonu: String? = null,
  var email: String? = null,
  var skrytkaEPuap: String? = null,
)

@Serializable
data class BlokJ(
  var treśćInformacji: String? = null
)

@Serializable
data class BlokK(
  var organZawiadomionyPrzezWierzyciela: String? = null,
)

@Serializable
data class BlokL(
  var dataSporządzenia: Data = Data(),
  var imieOsobyUpoważnionaDoDziałaniaWImieniuWierzyciela: String? = null,
  var nazwiskoOsobyUpoważnionaDoDziałaniaWImieniuWierzyciela: String? = null,
  var nrTelefonu: String? = null,
  var email: String? = null,
  var klauzulaInformacyjna: Boolean = false,
)

@Serializable
data class BlokL2( //BlokŁ
  override var posiadaBlok: Boolean = false,

  val zalaczniki: ArrayList<Zalacznik> = arrayListOf<Zalacznik>()
): BlokOpcjonalny

@Serializable
data class Adres(
  var kodKraju: String? = null,
  val adresPolski: AdresPolski = AdresPolski(),
  val adresZagraniczny: AdresZagraniczny = AdresZagraniczny()
)

@Serializable
data class AdresZagraniczny(  //com:TAdresZagraniczny
//  var kodKraju: String? = null,
  var kodPocztowy: String? = null,
  var miejscowosc: String? = null,
  var ulica: String? = null,
  var nrDomu: String? = null,
  var nrLokalu: String? = null,
)

@Serializable
data class AdresPolski(  //com:TAdresPolski
//  var kodKraju: String? = null,
  var wojewodztwo: String? = null,
  var powiat: String? = null,
  var gmina: String? = null,
  var miejscowosc: String? = null,
  var ulica: String? = null,

  var nrDomu: String? = null,
  var nrLokalu: String? = null,
  var kodPocztowy: String? = null,
)

@Serializable
data class Data(
  var data: LocalDate? = null
)

@Serializable
data class Kwota(
  var kwota: String? = null
)

interface BlokOpcjonalny {
  var posiadaBlok: Boolean
}